import React, { useState } from "react";
import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";

import {
  Button,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

import InputFieldText from "Components/Common/InputFieldText";

const initialFilters = {
  fromDate: null,
  toDate: null,
  buildingName: "",
  fscaNumber: "",
};

function FireNocDetailFilter({ setQuery, resetPage = () => {}, t }) {
  const isExtraLargeScreen = useMediaQuery("(max-width: 1620px)");

  const [{ fromDate, toDate, buildingName, fscaNumber }, setFilters] =
    useState(initialFilters);

  const clearBtnHandler = () => {
    resetPage();
    setFilters(initialFilters);
    setQuery({});
  };

  const searchBtnHandler = (e) => {
    e.preventDefault();
    resetPage();
    setQuery({
      fromDate: fromDate?.isValid() ? fromDate.format("MM-DD-YYYY") : "",
      toDate: toDate?.isValid() ? toDate.format("MM-DD-YYYY") : "",
      buildingName,
      fscaNumber,
    });
  };

  return (
    <form onSubmit={searchBtnHandler}>
      <Grid container columnSpacing={2} className="mt-2">
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          xl={isExtraLargeScreen ? 3 : 2}
        >
          <InputFieldText
            label={`${t("FSCA No.")}`}
            className="w-100 mb-2"
            value={fscaNumber}
            placeholder={t("Enter FSCA No.")}
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                fscaNumber: e.target.value,
              }))
            }
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          xl={isExtraLargeScreen ? 3 : 2}
        >
          <DatePicker
            label={t("Start Date")}
            className="w-100 mb-2"
            format="DD-MM-YYYY"
            value={fromDate}
            maxDate={toDate}
            slotProps={{ textField: { size: "small" } }}
            onChange={(date) =>
              setFilters((prev) => ({
                ...prev,
                fromDate: date,
              }))
            }
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          xl={isExtraLargeScreen ? 3 : 2}
        >
          <DatePicker
            label={t("End Date")}
            className="w-100 mb-2"
            format="DD-MM-YYYY"
            value={toDate}
            minDate={fromDate}
            slotProps={{ textField: { size: "small" } }}
            onChange={(date) =>
              setFilters((prev) => ({
                ...prev,
                toDate: date,
              }))
            }
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          xl={isExtraLargeScreen ? 3 : 2}
        >
          <InputFieldText
            label={t("Building Name")}
            className="w-100 mb-2"
            value={buildingName}
            placeholder={t("Enter Building Name")}
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                buildingName: e.target.value,
              }))
            }
          />
        </Grid>

        <Grid item>
          <Button variant="outlined" type="submit" className="me-3 mb-2">
            {t("Search")}
          </Button>
          <Button
            variant="outlined"
            onClick={clearBtnHandler}
            className="me-3 mb-2"
          >
            {t("Clear")}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

FireNocDetailFilter.propTypes = {
  setQuery: PropTypes.func,
  resetPage: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(FireNocDetailFilter);  
